import { signOut as signOutFirebase, sendPasswordResetEmail } from 'firebase/auth';
import { auth } from '@/config/firebase';
import { ApolloClient } from '@apollo/client';
import { MUTATION_UPDATE_USER } from '@/graphql/mutation/user';
import { UpdateUserInput, UpdateUserResponse, User } from '@/graphql/types/user';

export const signOut = () => signOutFirebase(auth);

export const resetPassword = (email: string) => sendPasswordResetEmail(auth, email);

export const updateUserProfile = async (
  apolloClient: ApolloClient<any>,
  data: {
    displayName?: string;
    photoURL?: string;
    phoneNumber?: string;
    email?: string;
    photo?: File;
  },
  updateContextUser?: (user: User) => Promise<void>
) => {
  const input: UpdateUserInput = {};
  if (data.displayName) input.display_name = data.displayName;
  if (data.photoURL) input.photo_url = data.photoURL;
  if (data.phoneNumber) input.phone_number = data.phoneNumber;
  if (data.email) input.email = data.email;
  if (data.photo) input.photo = data.photo;

  const { data: response } = await apolloClient.mutate<{
    updateUser: UpdateUserResponse;
  }>({
    mutation: MUTATION_UPDATE_USER,
    variables: { input },
  });

  if (response?.updateUser) {
    if (updateContextUser) {
      await updateContextUser(response.updateUser.user);
    }

    return response.updateUser;
  }
};
